import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';

interface ArticleItemProps {
  date?: string;
  title: string;
  slug?: string;
  linkText: string;
  image?: string;
}

const ArticleListItem: React.FC<ArticleItemProps> = ({ date, title, slug, linkText, image }) => (
  <Card hoverable={!!slug}>
    <div className="flex flex-col md:flex-row gap-6">
      {/* Image */}
      {image ? (
        <img
          src={image.replace('/privateImages/', '/privateImages/optimized/').replace('.webp', '-medium.webp')}
          srcSet={`
            ${image.replace('/privateImages/', '/privateImages/optimized/').replace('.webp', '-small.webp')} 384w,
            ${image.replace('/privateImages/', '/privateImages/optimized/').replace('.webp', '-medium.webp')} 578w,
            ${image.replace('/privateImages/', '/privateImages/optimized/').replace('.webp', '-large.webp')} 768w
          `}
          sizes="(max-width: 768px) 100vw, 192px"
          alt={`Illustrasjonsbilde for artikkelen: ${title}`}
          className="w-full md:w-48 h-32 object-cover rounded-lg flex-shrink-0"
          loading="lazy"
          decoding="async"
          width="578"
          height="433"
        />
      ) : (
        <div className="w-full md:w-48 h-32 bg-gradient-to-br from-primary-light to-primary rounded-lg flex-shrink-0 flex items-center justify-center">
          <svg className="w-12 h-12 text-white opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
      )}

      {/* Content */}
      <div className="flex-1">
        {/* Date Badge (only when a date is provided) */}
        {date && (
          <span className="inline-block px-3 py-1 bg-accent/10 text-accent text-sm rounded-full mb-3">
            {date}
          </span>
        )}

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-2 hover:text-primary transition-colors">
          {title}
        </h3>

        {/* Link or Not Available Message */}
        {slug ? (
          <Link
            to={slug === 'oppdragsvilkar' ? '/oppdragsvilkar' : `/article/${slug}`}
            className="text-primary hover:text-primary-dark hover:underline font-medium transition-colors inline-flex items-center"
          >
            {linkText}
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        ) : (
          <span className="text-gray-500 italic">{linkText} (ikke tilgjengelig)</span>
        )}
      </div>
    </div>
  </Card>
);

export default ArticleListItem;

